export enum SubCodeExceptionEnum {
    ExpiredToken = 1,
    UnauthorizedDataAccess = 2,
    UnauthorizedAction = 3
}
